export default __webpack_public_path__ + "static/media/cloud_upload-24px.767438a0.svg";